export default "__VITE_ASSET__Bg$Z_ftL__"